import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { PreviewProvider } from "@/components/app/PreviewGate";
import ProtectedRoute from "@/components/app/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Terms from "@/pages/Terms";
import ParentPlaybook from "@/pages/ParentPlaybook";
import Enrollment from "@/pages/Enrollment";
import Dashboard from "@/pages/Dashboard";
import ChildHome from "@/pages/ChildHome";
import SessionDetail from "@/pages/SessionDetail";
import CheckInPage from "@/pages/CheckInPage";
import SymptomLibrary, { SymptomDetail } from "@/pages/SymptomLibrary";
import Roadblocks from "@/pages/Roadblocks";
import Triage from "@/pages/Triage";
import Certificate from "@/pages/Certificate";
import Graduation from "@/pages/Graduation";
import FellOff from "@/pages/FellOff";
import SessionLibrary from "@/pages/SessionLibrary";
import PhotoGallery from "@/pages/PhotoGallery";
import FamilyTimeline from "@/pages/FamilyTimeline";
import Providers from "@/pages/Providers";
import Learn from "@/pages/Learn";
import BreatheFramework from "@/pages/BreatheFramework";
import Support from "@/pages/Support";
import PracticeShortcut from "@/pages/PracticeShortcut";
import FamilyCompare from "@/pages/FamilyCompare";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminFamilies from "@/pages/admin/AdminFamilies";
import AdminChildAudit from "@/pages/admin/AdminChildAudit";
import AdminActivity from "@/pages/admin/AdminActivity";
import AdminSecurity from "@/pages/admin/AdminSecurity";
import AdminCertificateTemplates from "@/pages/admin/AdminCertificateTemplates";
import AdminContent from "@/pages/admin/AdminContent";
import AdminBulkVideos from "@/pages/admin/AdminBulkVideos";
import AdminThriveStories from "@/pages/admin/AdminThriveStories";
import AdminProtectedRoute from "@/components/admin/AdminProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <ContentProvider>
        <PreviewProvider>
          <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          {/* Public policy landing page — linked from the enrollment Terms checkbox. */}
          <Route path="/terms" element={<Terms />} />
          <Route path="/enroll" element={<ProtectedRoute><Enrollment /></ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/child/:childId" element={<ProtectedRoute><ChildHome /></ProtectedRoute>} />
          <Route path="/child/:childId/session/:sessionNumber" element={<ProtectedRoute><SessionDetail /></ProtectedRoute>} />
          <Route path="/child/:childId/checkin" element={<ProtectedRoute><CheckInPage /></ProtectedRoute>} />
          <Route path="/child/:childId/certificate/:sessionNumber" element={<ProtectedRoute><Certificate /></ProtectedRoute>} />
          <Route path="/child/:childId/graduation" element={<ProtectedRoute><Graduation /></ProtectedRoute>} />
          <Route path="/child/:childId/triage" element={<ProtectedRoute><Triage /></ProtectedRoute>} />
          {/* Symptom Library is educational content — public for both parents and logged-out visitors.
              Backend /api/symptoms and /api/content/overrides are both public endpoints. */}
          <Route path="/library" element={<SymptomLibrary />} />
          <Route path="/library/:key" element={<SymptomDetail />} />
          <Route path="/roadblocks" element={<ProtectedRoute><Roadblocks /></ProtectedRoute>} />
          <Route path="/fell-off" element={<ProtectedRoute><FellOff /></ProtectedRoute>} />
          <Route path="/child/:childId/library" element={<ProtectedRoute><SessionLibrary /></ProtectedRoute>} />
          <Route path="/child/:childId/gallery" element={<ProtectedRoute><PhotoGallery /></ProtectedRoute>} />
          <Route path="/child/:childId/timeline" element={<ProtectedRoute><FamilyTimeline /></ProtectedRoute>} />
          <Route path="/providers" element={<ProtectedRoute><Providers /></ProtectedRoute>} />
          <Route path="/learn" element={<ProtectedRoute><Learn /></ProtectedRoute>} />
          <Route path="/learn/breathe-framework" element={<ProtectedRoute><BreatheFramework /></ProtectedRoute>} />
          <Route path="/learn/parent-playbook" element={<ProtectedRoute><ParentPlaybook /></ProtectedRoute>} />
          <Route path="/support" element={<ProtectedRoute><Support /></ProtectedRoute>} />
          <Route path="/child/:childId/practice" element={<ProtectedRoute><PracticeShortcut /></ProtectedRoute>} />
          <Route path="/family/compare" element={<ProtectedRoute><FamilyCompare /></ProtectedRoute>} />
          {/* --- Admin (separate app) --- */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>} />
          <Route path="/admin/families" element={<AdminProtectedRoute><AdminFamilies /></AdminProtectedRoute>} />
          <Route path="/admin/families/:childId" element={<AdminProtectedRoute><AdminChildAudit /></AdminProtectedRoute>} />
          <Route path="/admin/activity" element={<AdminProtectedRoute><AdminActivity /></AdminProtectedRoute>} />
          <Route path="/admin/content" element={<AdminProtectedRoute><AdminContent /></AdminProtectedRoute>} />
          <Route path="/admin/content/bulk-videos" element={<AdminProtectedRoute><AdminBulkVideos /></AdminProtectedRoute>} />
          <Route path="/admin/content/certificate-templates" element={<AdminProtectedRoute><AdminCertificateTemplates /></AdminProtectedRoute>} />
          <Route path="/admin/thrive-stories" element={<AdminProtectedRoute><AdminThriveStories /></AdminProtectedRoute>} />
          <Route path="/admin/security" element={<AdminProtectedRoute><AdminSecurity /></AdminProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      </PreviewProvider>
      </ContentProvider>
    </AuthProvider>
  );
}

export default App;
